var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',[_c('li',_vm._g({staticClass:"nitrozen-menu-item"},_vm.$listeners),[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }